export const firstLetterCapitalizeWords = (str: string): string => {
    if (str) {
        return str?.toLowerCase().replace(/\b\w/g, (char) => char?.toUpperCase());
    }
    return ""
};

export const formatPhoneNumber = (value: string) => {
    const cleaned = value?.replace(/\D/g, "");
    let formatted = "";
  
    if (cleaned.length > 0) {
      formatted = `(${cleaned.slice(0, 3)}`;
    }
    if (cleaned.length >= 4) {
      formatted += `) ${cleaned.slice(3, 6)}`;
    }
    if (cleaned.length >= 7) {
      formatted += `-${cleaned.slice(6, 10)}`;
    }
  
    return formatted;
  };

  export const requiredWithoutSpaces = () => {
    return /^\s*\S[\s\S]*$/;
}